import {
    UNITTYPES_CREATE_EDIT_OPEN_MODAL,
    UNITTYPES_CREATE_REQUEST,
    UNITTYPES_CREATE_RESULT,
    UNITTYPES_UPDATE_REQUEST,
    UNITTYPES_UPDATE_RESULT,
    UNITTYPES_GET_REQUEST,
    UNITTYPES_GET_RESULT,
} from 'Redux/actionTypes';

export const unitTypeCreateEditOpenModal = (data) => ({
    type: UNITTYPES_CREATE_EDIT_OPEN_MODAL,
    payload: data
})

export const unitTypeCreateRequest = (data) => ({
    type: UNITTYPES_CREATE_REQUEST,
    payload: data
})

export const unitTypeCreateResult = (result) => ({
    type: UNITTYPES_CREATE_RESULT,
    payload: result
})

export const unitTypeUpdateRequest = (data) => ({
    type: UNITTYPES_UPDATE_REQUEST,
    payload: data
})

export const unitTypeUpdateResult = (result) => ({
    type: UNITTYPES_UPDATE_RESULT,
    payload: result
})

export const unitTypeGetRequest = (data) => ({
    type: UNITTYPES_GET_REQUEST,
    payload: data
})

export const unitTypeGetResult = (result) => ({
    type: UNITTYPES_GET_RESULT,
    payload: result
})